import React from "react";
import { UploaderComponent } from "@syncfusion/ej2-react-inputs";

const Uploader = () => {
  const path = {
    saveUrl: process.env.REACT_APP_API_BASE_URL + "/contacts/upload",
  };

  const onUploadSuccess = (args) => {
    if (args.operation === "upload") {
      console.log("File uploaded successfully", args);
    }
  };
  const onUploadFailure = (args) => {
    console.log("File failed to upload", args);
  };

  const uploading = (args) => {
    const token = localStorage.getItem("accessToken");
    if (token)
      args.currentRequest.setRequestHeader("Authorization", `Bearer ${token}`);
  };

  return (
    <UploaderComponent
      id="uploader"
      autoUpload={true}
      multiple={false}
      asyncSettings={path}
      allowedExtensions=".xlsx"
      success={onUploadSuccess}
      failure={onUploadFailure}
      uploading={uploading}
    />
  );
};

export default Uploader;
